/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-18 10:10:30
 */

import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import EnumStationType from 'src/enums/enumStationType';
import DatePicker from 'src/types/iview/DatePicker';
import CheckLog from './checkLog';
import SnConfigApi, { SnConfigDOI } from '../api/snConfigApi';

export default class CheckLogService extends ListPageService {
    ctx: CheckLog;
 
    constructor (ctx: CheckLog) {
        super()
        this.ctx = ctx
    }

    @override
    createColumns (): ColDefCustom [] {
       return [
           {
               headerName: 'uuid',
               field: 'sn',
               minWidth: 160
           },
           {
               headerName: '文件名称',
               field: 'file_name',
               minWidth: 160
           },
           {
              headerName: '下载时间',
              field: 'time',
              minWidth: 160
           }
       ]
    }

    @override
    createBtnGroup (): Array<IconBtnItem> {
       return []
    }

    @override
	initSearchParams (): void {
		this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<SnConfigDOI.QueryRowDataParamsI>(),
            sn: this.ctx.sn,
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await SnConfigApi.searchLog({
            ...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count
		}
    }
}